/*
 * @Author: Vanny
 * @Date: 2019-10-23 16:50:24
 * @LastEditors: Vanny
 * @LastEditTime: 2020-02-28 20:52:10
 * @Description: axios
 */
import axios from 'axios'
import qs from 'querystring'

import native, { isMC } from '@/utils'

const axiosInterceptors = (service, e) => {
  service.interceptors.request.use(
    (config) => {
      const params = {
        key: e.key || e.token,
        app_pid: e.projId,
        lang: e.lang,
      }
      Object.keys(params).forEach((k) => {
        if (!params[k]) {
          delete params[k]
        }
      })

      if (config.method.toLowerCase() === 'get') {
        config.url = `${config.url}${
          config.url.indexOf('?') > -1 ? '&' : '?'
        }${qs.stringify(params)}`
      } else {
        config.params = params
      }

      return config
    },
    (error) => {
      // Do something with request error
      console.log(error) // for debug
      Promise.reject(error)
    }
  )
}

export const instance = axios.create({
  baseURL:
    process.env.NODE_ENV !== 'production'
      ? isMC()
        ? 'https://help.mc.app/api/'
        : 'https://help-cms-test.duoke.net/api/'
      : '/api/',
  headers: { 'Content-Type': 'application/json' },
})

const getAppInfo = () => {
  const info = native.appInfo
  if (info.projId) {
    axiosInterceptors(instance, info)
  } else {
    setTimeout(getAppInfo, 100)
  }
}
axiosInterceptors(instance, native.appInfo)
getAppInfo()

export default {}



// WEBPACK FOOTER //
// ./src/utils/axios.js